import React, { VFC } from 'react';
import { IIconProps } from './types';

const CrossIcon: VFC<IIconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="3 3 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m10.828 5.172-5.656 5.656M10.828 10.828 5.172 5.172"
      stroke={color}
      strokeLinecap="round"
    />
  </svg>
);

export default CrossIcon;
